import { heroStats, heroTicker } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -right-24 top-10 h-[420px] w-[420px] rounded-full bg-primary-100/50 blur-3xl" />
      <div className="pointer-events-none absolute -left-32 bottom-0 h-[320px] w-[320px] rounded-full bg-accent-100/50 blur-3xl" />

      <div className="relative mx-auto w-full max-w-shell px-4 pb-16 pt-28 md:px-8 md:pb-24 md:pt-36">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* 左：文 */}
          <div data-reveal>
            <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-4 py-1.5">
              <span className="flex h-2 w-2 items-center justify-center rounded-full bg-primary-500" />
              <span className="text-xs tracking-wide text-primary-700">
                社区共创 · 每日整理 · 不站队
              </span>
            </div>

            <h1 className="mt-6 font-heading text-4xl font-bold leading-tight tracking-tight text-foreground-950 md:text-6xl">
              17黑料网
            </h1>
            <p className="mt-4 font-heading text-xl leading-relaxed text-foreground-800 md:text-2xl">
              把散落各处的黑历史，
              <br className="hidden md:block" />
              整理成一份看得下去的档案。
            </p>

            <p className="mt-6 max-w-xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
              这里收录 <strong className="font-medium text-foreground-900">17黑料网</strong> 相关的
              翻车合集、塌房记录、负面新闻与争议事件，也把社区里反复出现的槽点汇总成条目。
              想快速了解 17黑料网到底有哪些黑料，看这一份就够了。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-base" />
                查看热度榜单
              </a>
              <a
                href="#feed"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-foreground-300 px-6 py-3 text-sm text-foreground-900 transition-colors hover:border-foreground-900 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-gallery-view-2 text-base" />
                浏览翻车合集
              </a>
            </div>

            <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4 border-t border-background-300 pt-6">
              {heroStats.map((stat) => (
                <div key={stat.label}>
                  <dt className="text-xs tracking-wide text-foreground-500">{stat.label}</dt>
                  <dd className="mt-1 font-display text-3xl leading-none text-foreground-950 md:text-4xl">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          {/* 右：图 */}
          <div data-reveal className="relative">
            <div className="relative h-[360px] w-full overflow-hidden rounded-lg md:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20cover%20artwork%20of%20torn%20paper%20collage%20layers%20in%20deep%20crimson%2C%20warm%20gold%20and%20charcoal%20tones%2C%20film%20grain%20texture%2C%20bold%20geometric%20shapes%2C%20dramatic%20moody%20lighting%2C%20artistic%20poster%20composition%2C%20no%20text%2C%20no%20people%2C%20high%20detail%2C%20harmonious%20balanced%20layout&width=1000&height=1250&seq=hl-hero-01&orientation=portrait"
                alt="17黑料网档案封面"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/10 to-transparent" />

              <div className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1.5 backdrop-blur">
                <i className="ri-pushpin-2-line text-sm text-primary-600" />
                <span className="text-xs text-foreground-800">本周封面</span>
              </div>

              <div className="absolute inset-x-5 bottom-5 flex items-end justify-between gap-4">
                <div>
                  <p className="text-xs tracking-wide text-background-200">封面档案</p>
                  <p className="mt-1 font-heading text-lg font-bold text-background-50">
                    改版当天的 24 小时
                  </p>
                </div>
                <a
                  href="#feed"
                  className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-background-50 text-foreground-950 transition-colors hover:bg-accent-500 cursor-pointer"
                  aria-label="查看封面档案"
                >
                  <i className="ri-arrow-right-up-line text-lg" />
                </a>
              </div>
            </div>

            <div className="animate-float absolute -bottom-6 -left-4 hidden w-44 rounded-lg border border-background-200 bg-background-50 p-4 md:block">
              <div className="flex items-center gap-2">
                <i className="ri-fire-fill text-accent-500" />
                <span className="text-xs text-foreground-500">今日热度</span>
              </div>
              <p className="mt-2 font-display text-3xl leading-none text-foreground-950">96</p>
              <div className="mt-3 h-1.5 w-full rounded-full bg-background-200">
                <div className="h-full w-[96%] rounded-full bg-primary-500" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 滚动快讯条 */}
      <div className="relative border-y border-background-200 bg-background-50">
        <div className="flex items-center">
          <div className="flex flex-none items-center gap-2 bg-primary-500 px-4 py-3 md:px-6">
            <i className="ri-flashlight-line text-sm text-background-50" />
            <span className="text-xs tracking-wide text-background-50">快讯</span>
          </div>
          <div className="relative min-w-0 flex-1 overflow-hidden">
            <div className="animate-marquee flex w-max items-center">
              {[...heroTicker, ...heroTicker].map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="flex items-center gap-3 whitespace-nowrap px-6 text-xs text-foreground-600 md:text-sm"
                >
                  <span className="h-1 w-1 rounded-full bg-accent-500" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}